import { render, staticRenderFns } from "./T1ATabs.vue?vue&type=template&id=875129b6&scoped=true&"
import script from "./T1ATabs.vue?vue&type=script&lang=js&"
export * from "./T1ATabs.vue?vue&type=script&lang=js&"
import style0 from "./T1ATabs.vue?vue&type=style&index=0&id=875129b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875129b6",
  null
  
)

export default component.exports